import isNil from "lodash/fp/isNil";
import ClientObject from "../ClientObject";
export default class Permission extends ClientObject {
  name: any;
  constructor(entity) {
    super();

    if (!isNil(entity)) {
      const { name } = entity;
      this.name = name;
    }
  }
}
export const PERMISSIONS = {
  ADMINISTRATION: "Administration",
};
export const ROLES = {
  ADMIN: "PIM_Admin",
};
